'use client';

import React, { memo, useMemo } from 'react';

interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  return (
    <div className={containerClassName} onClick={onClick}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        {/* Outer circle */}
        <circle cx="20" cy="20" r="19" stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.25" />
        {/* Runway centerline — vertical */}
        <line x1="20" y1="10" x2="20" y2="30" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        {/* Left wing */}
        <path
          d="M20 22 L10 28"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        {/* Right wing */}
        <path
          d="M20 22 L30 28"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        {/* Nose dot */}
        <circle cx="20" cy="10" r="1.5" fill="currentColor" />
      </svg>
    </div>
  );
});

export default AppLogo;
